import { render, staticRenderFns } from "./TheGroupList.vue?vue&type=template&id=05cb5470"
import script from "./TheGroupList.vue?vue&type=script&lang=js"
export * from "./TheGroupList.vue?vue&type=script&lang=js"
import style0 from "./TheGroupList.vue?vue&type=style&index=0&id=05cb5470&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports